import store from '@/store';
export const option = {
    height: 'auto',
    calcHeight: 80,
    tip: false,
    delBtn: true,
    addBtnText: '新增保证金公司',
    editBtn: true,
    addBtn: true,
    searchShow: true,
    searchMenuSpan: 6,
    searchLabelWidth: 100,
    labelWidth: 150,
    border: true,
    index: true,
    selection: false,
    viewBtn: false,
    dialogType: 'dialog',
    dialogClickModal: false,
    column: [{
            label: "保证金公司名称",
            prop: "securityDeptName",
            type: "input",
            search: true,
            searchOrder: 100,
            span: 24,
            searchLabelWidth: 120,
            rules: [{
                required: true,
                message: "请输入保证金公司名称",
                trigger: "blur",
            }, ],
        },
        {
            label: "公司名称",
            prop: "deptId",
            type: "select",
            filterable: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            search: true,
            searchMultiple: true,
            searchClearable: true,
            defaultExpandAll: true,
            searchOrder: 10,
            hide: true,
            dicData: [],
            props: {
                label: "deptName",
                value: "id",
            },
        },
        {
            label: "绑定公司",
            prop: "deptIds",
            type: "select",
            span: 24,
            filterable: true,
            search: false,
            multiple: true,
            searchMultiple: true,
            searchClearable: true,
            defaultExpandAll: true,
            searchOrder: 10,
            dicData: [],
            hide: true,
            props: {
                label: "deptName",
                value: "id",
            },
            rules: [{
                required: true,
                message: "请选择绑定公司",
                trigger: "change",
            }, ],
        },
        {
            label: "id",
            prop: "id",
            display: false,
            hide: true,
        },
        {
            label: "保证金名称",
            prop: "businessCode",
            span: 24,
            hide: true,
            display: false,
        },
        {
            label: "绑定公司",
            prop: "deptIdName",
            span: 24,
            search: false,
            display: false,
            hide: false,
        },
        {
            label: "保证金金额",
            prop: "securityMoney",
            display: false,
        },
        {
            label: "保证金余额",
            prop: "securityMoneyBalance",
            search: false,
            type: "select",
            display: false,
            dicData: [],
        },
        {
            label: "跟投占用金额",
            prop: "followMoney",
            display: false,
        },
        {
            label: "租赁金额合计",
            prop: "leaseAmount",
            display: false,
        }
    ],
}
